import i18next, { t } from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Language, LocaleCode } from '../enum';
export var formatNumberByLocale = function (value, options) {
  if (value === null || value === undefined) return '';
  var localeCode = t('numberFormat.localeCode', {
    lng: i18next.language,
    defaultValue: LocaleCode.EN_US
  });
  return value.toLocaleString(localeCode, options);
};
export var getLocaleInputNumberFormat = function () {
  var thousandSeparator = t('numberFormat.thousandSeparator', {
    lng: i18next.language,
    defaultValue: ','
  });
  var decimalSeparator = t('numberFormat.decimalSeparator', {
    lng: i18next.language,
    defaultValue: '.'
  });
  return {
    thousandSeparator: thousandSeparator,
    decimalSeparator: decimalSeparator
  };
};
export var getLanguage = function () {
  return i18next.language;
};
export var formatDateToLocaleUppercase = function (input) {
  if (!input) return '';
  if (input === 'Total') return 'TOTAL';
  var language = i18next.language;
  if (language === Language.FR) {
    if (input.includes('(')) {
      return input.replaceAll(/([^(]+)(\([^)]+\))?/g, function (_, outside, inside) {
        var upper = outside.toLocaleUpperCase(language).trim();
        return inside ? "".concat(upper, " ").concat(inside) : upper;
      }).trim();
    }
    return input;
  }
  return input.toLocaleUpperCase(language);
};
export var handleLocaleFormat = function (format, currency) {
  var language = i18next.language;
  if (language === Language.FR) {
    return "".concat(format, " ").concat(currency, " ");
  }
  return "".concat(currency).concat(format, " ");
};
export var usePageTranslation = function () {
  var _a;
  var i18n = useTranslation().i18n;
  var reqLang = ((_a = navigator.language) === null || _a === void 0 ? void 0 : _a.split(',')[0].split('-')[0]) || Language.EN;
  var lang = [Language.EN, Language.FR].includes(reqLang) ? reqLang : Language.EN;
  var trans = useMemo(function () {
    return i18n.getFixedT(lang);
  }, [i18n, lang]);
  return {
    lang: lang,
    trans: trans
  };
};